import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';
import { notify, type Toast } from './uiSlice';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

/** Shorthand for the pattern every mutation handler repeats. */
export function useNotify() {
  const dispatch = useAppDispatch();
  return useCallback(
    (message: string, severity: Toast['severity'] = 'success') => {
      dispatch(notify(message, severity));
    },
    [dispatch],
  );
}
